import { z } from 'zod'
import { AUTH_PASSWORD_MIN_LENGTH } from '../constants'

type Translate = (key: string) => string

export function createAccountSchema(t: Translate) {
    return z.object({
        email: z.string()
        .min(1, {message: t('customerAuth.emailRequiredError')})
        .email({ message: t('customerAuth.emailInvalidError') }),
        password: z.string()
            .min(1, { message: t('customerAuth.passwordRequiredError') })
            .min(AUTH_PASSWORD_MIN_LENGTH, { message: t('customerAuth.passwordTooShortError') }),
        confirmPassword: z.string()
            .min(1, { message: t('customerAuth.confirmPasswordRequiredError') }),
    }).refine((data) => data.password === data.confirmPassword, {
        message: t('customerAuth.passwordMismatchError'),
        path: ['confirmPassword'],
    })
}